import type {
  AppLayoutNavigation,
  SidebarNavigation,
} from "@app/components/navigation/config";
import { matchesRoutePattern } from "@app/components/navigation/config";
import {
  useSetContentWidth,
  useSetSubNavigation,
} from "@app/components/sparkle/AppLayoutContext";
import { useWorkspace } from "@app/lib/auth/AuthContext";
import { useAppRouter } from "@app/lib/platform";
import { ActionDocumentTextIcon } from "@dust-tt/sparkle";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

// The 업무(Business) section's left sub-nav — mirrors KnowledgeRouterLayout.
// Currently one module (세금계산서); more Korean business-ops modules (주주명부,
// 전자서명 등) will be added here as sibling menu entries. The menu ids are
// outside the shared AppLayoutNavigation.id union (used only as React keys), so
// the nav is asserted to SidebarNavigation[] here.
export function BizRouterLayout() {
  const { t } = useTranslation();
  const owner = useWorkspace();
  const router = useAppRouter();
  const currentRoute = router.pathname;

  const subNavigation = useMemo<SidebarNavigation[]>(() => {
    const base = `/w/${owner.sId}/biz`;
    const menus = [
      {
        id: "tax-invoices",
        label: t("biz.navTaxInvoices", "세금계산서"),
        icon: ActionDocumentTextIcon,
        href: `${base}/tax-invoices`,
        current: matchesRoutePattern(currentRoute, [
          "/w/[wId]/biz/tax-invoices",
        ]),
      },
    ] as unknown as AppLayoutNavigation[];

    return [
      {
        id: "workspace",
        label: t("biz.navSectionLabel", "업무"),
        menus,
      },
    ];
  }, [owner.sId, currentRoute, t]);

  useSetSubNavigation(subNavigation);
  useSetContentWidth("wide");

  return <Outlet />;
}
